import { useRecentWizards } from 'hooks/useRecentWizards'
import { FOR_YOU_RECENT_WIZARDS_FILE_THRESHOLD, getCardMaps, LEVEL_CARDS, RECENT_WIZARDS_MAX_COUNT } from '../Constants'
import { WizardOrLevelCard } from '../Types'
import { useMobileHomeRecentFiles } from 'screens/blaze/Home/MobileHome/hooks/useMobileHomeRecentFiles'
import { useRegistrationData } from 'hooks/queries/users/useRegistrationData'
import { uniq } from 'lodash'

let cardMaps: ReturnType<typeof getCardMaps>

type Return = {
  cards: WizardOrLevelCard[]
  type: 'recently_used' | 'experienced' | 'inexperienced'
}

export const useForYouItems = (): Return => {
  const { files } = useMobileHomeRecentFiles()
  const recentlyUsedWizards = useRecentWizards({ count: RECENT_WIZARDS_MAX_COUNT })?.data?.data?.channels ?? []
  const experience =
    useRegistrationData({ cacheTime: Infinity })?.data?.user_registration_data?.marketing_experience_level ?? 0

  if (!cardMaps) {
    cardMaps = getCardMaps()
  }

  const { wizardCardMap, levelCardMap } = cardMaps

  const getForYouItems = () => {
    if (files.length >= FOR_YOU_RECENT_WIZARDS_FILE_THRESHOLD) {
      const cards = uniq(
        recentlyUsedWizards
          .map((w) => {
            let card: WizardOrLevelCard = wizardCardMap[w.channel]

            if (card?.forYouLevel) {
              card = levelCardMap[card.forYouLevel]
            }

            return card
          })
          .filter(Boolean),
      )

      if (cards.length > 0) {
        return {
          type: 'recently_used' as const,
          cards,
        }
      }
    }

    if (experience >= 2) {
      return {
        type: 'experienced' as const,
        cards: LEVEL_CARDS.L1.FOR_YOU_EXPERIENCED,
      }
    }

    return {
      type: 'inexperienced' as const,
      cards: LEVEL_CARDS.L1.FOR_YOU_INEXPERIENCED,
    }
  }

  return getForYouItems()
}
